<template>
  <div :class="divWidthChange" class="conteudoWidth">
    <fccTitlePage :titlePage="titlePage"></fccTitlePage>

    <div class="row">
      <div class="col-sm-12">
        <fccTable
          striped
          hover
          :fields="fieldsEscolaridade"
          responsive
          :porPage="itemPorPage"
          search
          pagination
          fieldVisibility
          pdf
          csv
          xls
          :titlePage="titlePage"
          :titlePDF="titlePDF"
          :actions="actionsEscolaridade"
          addFilter
          :items="listarEscolaridade"
        >
        </fccTable>
      </div>
    </div>

    <fccModal
      centered
      idModal="editEscolaridade"
      :titleModal="titleModal"
      escondeFooter
      travaEsc
      travaBack
    >
      <form
        @submit.prevent="escolaridade.id === 0 ? addEscolaridade() : editEscolaridade()"
        autocomplete="off"
      >
        <div class="row innerPage">
          <div class="col-sm-12">
            <input v-model="escolaridade.id" type="hidden" />
            <fccInput extraClasses="inputLabel" v-model="escolaridade.codescolaridade" required
              >Código</fccInput
            >
          </div>
        </div>

        <div class="row innerPage">
          <div class="col-sm-12">
            <label>Tipo de Escolaridade</label>
            <v-select
              placeholder="Selecione um tipo"
              v-model="escolaridade.tipoescolaridade"
              label="descricao"
              :options="listarTipoEscolaridade"
              :reduce="(temp) => temp.id"
              :clearable="false"
            />
          </div>
        </div>

        <div class="row innerPage">
          <div class="col-sm-12">
            <fccInput extraClasses="inputLabel" v-model="escolaridade.descricao"
              >Descrição</fccInput
            >
          </div>
        </div>

        <div class="row innerPage">
          <div class="col-sm-12 text-right">
            <fccButton classeAdd="form-control" tipo="submit">{{ labelsSystem.salvar }}</fccButton>
          </div>
        </div>
      </form>
    </fccModal>
  </div>
</template>
<script>
import axios from 'axios'
import store from '@/store'

export default {
  data() {
    return {
      sortBy: 'ordem',
      titlePage: 'Escolaridade',
      titleModal: '',
      titlePDF: 'Escolaridade',
      listarTipoEscolaridade: [],
      listarEscolaridade: [],
      baseUrlGestaoProjetosConcurso: '',
      escolaridade: [],
      itemPorPage: '100',
      actionsEscolaridade: [
        {
          button: true,
          funcaoButton: 'editEscola',
          icon: 'edit',
          tooltip: 'Editar',
          objpermCodigo: store.state.permissaoMenu.editar
        },
        {
          button: true,
          funcaoButton: 'deleteEscolaridade',
          icon: 'trash',
          tooltip: 'Excluir',
          objpermCodigo: store.state.permissaoMenu.excluir
        }
      ],
      fieldsEscolaridade: [
        { key: 'id', label: 'ID', sortable: true, active: true },
        { key: 'codescolaridade', label: 'Código', sortable: true, active: true },
        { key: 'descricao', label: 'Descrição', sortable: true, active: true },
        { key: 'descTipoEscolaridade', label: 'Tipo', sortable: true, active: true },
        { key: 'actions', label: '', tdClass: 'no-print', thClass: 'no-print', active: true }
      ]
    }
  },
  methods: {
    carregaTipoEscolaridade: function () {
      this.carregaTexto(this.codeMensagem('C01'))

      return axios
        .get(
          this.baseUrlGestaoProjetosConcurso + 'TipoEscolaridade/Listar',
          this.dadosLoginSession.fccTokenHeaders
        )
        .then((response) => {
          this.listarTipoEscolaridade = response.data
          this.listandoEscolaridade()
        })
        .catch(this.setErrorSystem)
    },
    listandoEscolaridade: function () {
      this.carregaTexto(this.codeMensagem('C01'))
      axios
        .get(
          this.baseUrlGestaoProjetosConcurso + 'Escolaridade/Listar',
          this.dadosLoginSession.fccTokenHeaders
        )
        .then((response) => {
          response.data.forEach((escol) => {
            escol.descTipoEscolaridade = this.listarTipoEscolaridade.find(
              (tp) => tp.id === escol.tipoescolaridade
            ).descricao
          })
          this.listarEscolaridade = response.data
        })
        .catch(this.setErrorSystem)
        .finally(this.carregaTexto)
    },
    addField: function () {
      this.titleModal = 'Adicionar escolaridade'
      this.escolaridade = {}
      this.escolaridade.id = 0
      this.$root.$emit('bv::show::modal', 'editEscolaridade')
    },
    editEscola: function (_, item) {
      this.titleModal = 'Editar escolaridade'
      this.escolaridade = item
      this.$root.$emit('bv::show::modal', 'editEscolaridade')
    },
    editEscolaridade: function () {
      this.carregaTexto(this.codeMensagem('C03'))
      axios
        .put(
          this.baseUrlGestaoProjetosConcurso + 'Escolaridade/Alterar',
          this.escolaridade,
          this.dadosLoginSession.fccTokenHeaders
        )
        .then(() => {
          this.escolaridade = {}
          this.listandoEscolaridade()
          this.callToast(this.mensagensUpdate.editado, 'success')
          this.$root.$emit('bv::hide::modal', 'editEscolaridade')
        })
        .catch(this.setErrorSystem)
        .finally(this.carregaTexto())
    },
    addEscolaridade: function () {
      this.carregaTexto(this.codeMensagem('C03'))
      axios
        .post(
          this.baseUrlGestaoProjetosConcurso + 'Escolaridade/Adicionar',
          this.escolaridade,
          this.dadosLoginSession.fccTokenHeaders
        )
        .then(() => {
          this.escolaridade = {}
          this.listandoEscolaridade()
          this.callToast(this.mensagensUpdate.adicionado, 'success')
          this.$root.$emit('bv::hide::modal', 'editEscolaridade')
        })
        .catch((error) => {
          this.setErrorSystem(error)
        })
        .finally(this.carregaTexto())
    },
    deleteEscolaridade: function (_, item) {
      this.callConfirm(this.mensagemExcluir, item.descricao).then((result) => {
        if (result.value) {
          this.carregaTexto(this.codeMensagem('C03'))
          axios
            .delete(
              this.baseUrlGestaoProjetosConcurso + 'Escolaridade/Excluir/' + item.id,
              this.dadosLoginSession.fccTokenHeaders
            )
            .then(() => {
              this.listandoEscolaridade()
              this.callToast(this.mensagensUpdate.excluido, 'success')
            })
            .catch((error) => {
              this.setErrorSystem(error)
            })
            .finally(this.carregaTexto())
        }
      })
    }
  },
  mounted: function () {
    this.baseUrlGestaoProjetosConcurso = store.state.baseUrlGestaoProjetos
    this.carregaTipoEscolaridade()
  }
}
</script>
